<div class="mb-4">
  <h5>Target</h5>
  @for (option of targetOptions; track option.id) {
  <c-form-check>
    <input cFormCheckInput type="radio" [id]="'targetOption-' + option.id" [value]="option.id"
      [checked]="selectedTargetType === option.id" (click)="onTargetTypeChange(option.id)" name="targetType" disabled />
    <label cFormCheckLabel [for]="'targetOption-' + option.id">{{ option.label }}</label>
  </c-form-check>
  }
</div>


  @if (polyTargetControl) {
  <div class="mb-4">
    <ng-container *ngTemplateOutlet="crossAppRelationshipTarget"></ng-container>
  </div>
}

@if (polyRelationshipTypeControl && isRelationshipTypeVisible) {
  <div class="mb-4">
    <app-polymorphic-control [c]="polyRelationshipTypeControl"></app-polymorphic-control>
  </div>
}

@if (polyMinimumControl) {
  <div class="mb-4">
  <app-polymorphic-control [c]="polyMinimumControl"></app-polymorphic-control>
  </div>
}

@if (polyMaximumControl) {
  <div class="mb-4">
  <app-polymorphic-control [c]="polyMaximumControl"></app-polymorphic-control>
  @if (isCardinalityInvalid) {
    <small class="text-danger d-block mt-1">
      <i class="cil-warning"></i> {{ cardinalityErrorMessage }}
    </small>
  }
  </div>
}

<div class="mb-4">
  <h5>Link</h5>
  @for (linkType of linkTypeOptions; track linkType) {
    <c-form-check>
      <input cFormCheckInput type="radio" [id]="'linkOption-' + linkType" [value]="linkType"
        [checked]="selectedLinkType === linkType" (click)="onLinkTypeChange(linkType)" name="linkType" [disabled]="isLinkDisabled" />
      <label cFormCheckLabel [for]="'linkOption-' + linkType">{{ RelationshipLinkType[linkType] }}</label>
    </c-form-check>
  }
</div>

@if (polyTabTitleControl) {
  <div class="mb-4">
    <h5>View</h5>
    <app-polymorphic-control [c]="polyTabTitleControl"></app-polymorphic-control>
  </div>
}

<!-- <div class="mb-4">
  <div class="d-flex justify-content-between align-items-center">
    <h5>Aggregations</h5>
    <button type="button" class="btn btn-sm btn-icon" (click)="onCreateNewFieldClicked()" aria-label="Add aggregation"
      title="Add aggregation">
      <svg cIcon name="cilPlus"></svg>
    </button>
  </div>
</div> -->


<ng-template #crossAppRelationshipTarget>
  <optima-dynamic-tabs [tabConfig]="xAppCapTabConfig" (tabChanged)="onAppTabChanged($event)"></optima-dynamic-tabs>
  <app-polymorphic-control  [c]="polyTargetControl"></app-polymorphic-control>
</ng-template>